import React from 'react';
import LegalLayout, { LegalH2, LegalUL, COMPANY } from '../../components/LegalLayout';

const RefundPolicy = () => (
  <LegalLayout title="Refund Policy" lastUpdated="May 11, 2026">
    <p>
      This Refund Policy explains when and how {COMPANY.name} ("<strong>NoFee</strong>") issues refunds for paid
      services. It applies to NoFee subscription fees only. Customer orders placed at Restaurants are governed
      separately — see Section 4 below.
    </p>

    <LegalH2>1. NoFee Subscription Fees (Restaurants)</LegalH2>
    <LegalUL>
      <li><strong>Monthly plans:</strong> non-refundable for the current billing period. You may cancel at any time;
        cancellation takes effect at the end of the current period. You will not be charged for the next period.</li>
      <li><strong>Annual plans:</strong> if you cancel within the first 14 days, you may request a full refund of the
        annual fee. After 14 days, annual plans are non-refundable, but you may still cancel renewal at any time.</li>
      <li><strong>Free trial:</strong> if NoFee offers a free trial, no payment is taken until the trial ends. You will
        not be charged if you cancel before the trial expires.</li>
    </LegalUL>

    <LegalH2>2. How to Request a Refund</LegalH2>
    <ol className="list-decimal pl-6 space-y-2 marker:text-gold-400 marker:font-bold">
      <li>Email <a href="mailto:support@nofee.restaurant" className="text-gold-400 hover:text-gold-300">support@nofee.restaurant</a> from the email address on your account.</li>
      <li>Include your restaurant name and the reason for the refund request.</li>
      <li>We will respond within 3 business days. Approved refunds are returned to the original payment method within 5–10 business days, depending on your bank.</li>
    </ol>

    <LegalH2>3. Exceptions</LegalH2>
    <p>We do not issue refunds for:</p>
    <LegalUL>
      <li>Partial months or unused time on a monthly plan after the first day of the billing period;</li>
      <li>Accounts terminated for violation of our <a href="/terms" className="text-gold-400 hover:text-gold-300">Terms of Service</a>;</li>
      <li>Third-party fees (Stripe processing fees, Twilio SMS/WhatsApp fees, GoDaddy domain fees, etc.);</li>
      <li>Lost revenue, indirect damages, or any consequential loss alleged due to a Service outage.</li>
    </LegalUL>

    <LegalH2>4. Customer Orders at Restaurants</LegalH2>
    <p>Refunds for individual orders placed with Restaurants on the platform are <strong>handled directly by the
      Restaurant</strong>. NoFee is not the seller or merchant of record for those orders. If you have an issue with
      an order (wrong items, food quality, no-show delivery), contact the Restaurant directly using the phone number
      on its NoFee page. Stripe chargebacks are also processed against the Restaurant, not NoFee.</p>

    <LegalH2>5. NoFee Rewards Credit</LegalH2>
    <p>NoFee Rewards credits are promotional and cannot be exchanged for cash. They have no monetary value outside the
      NoFee platform. See the <a href="/rewards-terms" className="text-gold-400 hover:text-gold-300">Rewards Program Terms</a> for
      forfeiture and adjustment rules.</p>

    <LegalH2>6. Chargebacks</LegalH2>
    <p>If you initiate a chargeback with your bank or card issuer instead of contacting us first, your account may be
      immediately suspended pending investigation. We always prefer to resolve issues directly — please email us before
      disputing a charge.</p>

    <LegalH2>7. Changes to This Policy</LegalH2>
    <p>We may update this Refund Policy from time to time. Material changes will be notified by email or in-app banner.
      Changes apply to subscriptions billed after the effective date.</p>

    <LegalH2>8. Contact</LegalH2>
    <p>
      <strong>{COMPANY.name}</strong><br />
      {COMPANY.address}<br />
      {COMPANY.city}, {COMPANY.country}<br />
      <a href="mailto:support@nofee.restaurant" className="text-gold-400 hover:text-gold-300">support@nofee.restaurant</a>
    </p>
  </LegalLayout>
);

export default RefundPolicy;
